import {
  ApolloClient,
  HttpLink,
  InMemoryCache,
  ApolloLink,
  from
} from '@apollo/client/core'
import { onError } from '@apollo/client/link/error'
import signWrap from '@/apollo-client/sign'
import redirectUrl from '@/utils/redirect-url'
import { Toast } from 'vant'

const cache = new InMemoryCache()

const httpLink = new HttpLink({
  uri: process.env.VUE_APP_BASE_API
})

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach((item: any) => {
      console.log(item)
      switch (item.err) {
        case 400:
          Toast.fail('请求异常，请稍后重试！(code: 400)')
          break
        case 542:
          Toast.fail('请求异常，请稍后重试！(code: 542)')
          break
        case 544:
          Toast.fail('请求异常，请稍后重试！(code: 544)')
          break
        case 546:
          Toast.fail('请求异常，请稍后重试！(code: 546)')
          break
        case 547:
          Toast.fail('请求异常，请稍后重试！(code: 547)')
          break
        case 543:
        case 545:
          Toast.fail('长时间未操作，请重新登录！')
          if (!window.GH_NATIVE_SDK.isInAppWebview()) {
            redirectUrl()
          }
          break
        default:
          Toast.fail('请求异常，请稍后重试！')
          break
      }
    })
  }
  // 网络错误处理
  if (networkError) console.log(`[Network error]: ${networkError}`)
})

const additiveLink = new ApolloLink((operation, forward) => {
  operation.setContext(() => ({
    headers: {
      'content-type': 'application/json',
      ...signWrap(operation)
    }
  }))

  return forward(operation).map(data => {
    console.log(data.data)
    return data
  })
})

const apolloClient = new ApolloClient({
  cache,
  link: from([additiveLink, errorLink, httpLink])
})

export default apolloClient
